import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ConfirmationService, MessageService } from 'primeng/api';

import { DescontoService } from '../desconto.service';
import { Desconto, GrupoDesconto } from '../models/desconto';
import { Produto } from '../../produto/models/produto';
import { ProdutoService } from '../../produto/produto.service';

@Component({
  selector: 'app-desconto',
  templateUrl: './desconto.component.html',
  styleUrls: ['./desconto.component.scss']
})
export class DescontoComponent implements OnInit {

  constructor(private descontoService: DescontoService,
              private produtoService: ProdutoService,
              private router: Router,
              private messageService: MessageService,
              private confirmationService: ConfirmationService) { }

  public listaDesconto: Desconto[] = [];
  public listaGrupo: GrupoDesconto[] = [];
  public listaProduto: Produto[] = [];
  public desconto: Desconto;
  public selectedGrupo: GrupoDesconto;
  public selectedProduto: Produto[] = [];
  

  //TODO - Definir regra de Insert / Delete + Edição Grupo / Produto
  public flagEdit: boolean = true;
  public flagDelete: boolean = false;
  public flagDisabledGrupo: boolean =true;
  public flagDisabledProduto: boolean = true;

  public displayMsg: boolean = false;
  public caixaDialog: boolean;
  public submitted: boolean;

  ngOnInit(): void {
    this.selectedGrupo = { idGrupoDesconto: 0, nome: '', cdGrupoDesconto: '', }
    this.getDescontos();
    this.getGrupo();
    this.getProdutos();
  }


  getDescontos() {
    this.descontoService.getDescontos().subscribe(
      (res) => {
        if (res) {
          this.listaDesconto = res;
        }
      },
      err => {
        console.log("ERRO GD-LIST");
        console.log(err);
      }
    );
  }

  getGrupo() {
    this.descontoService.getGruposDesconto().subscribe(
      (res) => {
        if (res) {
          this.listaGrupo = res;
        }
      },
      err => {
        console.log("ERRO DESCONTO - GRUPO ");
        console.log(err);
      }
    );
  }

  getProdutos() {
    this.produtoService.getProdutosMobile().subscribe(
      (res) => {
        if (res) {
          this.listaProduto = res;
        }
      },
      err => {
        console.log("ERRO DESCONTO - GRUPO ");
        console.log(err);
      }
    );
  }


  getSelectedGrupo(idGrupoDesconto: number) {
    return this.listaGrupo.find(x => x.idGrupoDesconto === idGrupoDesconto);
  }

  SetGrupo() {
    this.desconto.idGrupoDesconto = this.selectedGrupo.idGrupoDesconto;
  }

  getProdutoChecked(idGrupoDesconto: number) {
    return this.listaProduto.filter(x => x.idGrupoDesconto === idGrupoDesconto);
  }


  openNew() {
    this.submitted = false;
    this.caixaDialog = true;
    this.desconto = {};
  }

  edit(desconto: Desconto) {
    this.selectedProduto = this.getProdutoChecked(desconto.idGrupoDesconto);
    this.selectedGrupo = this.getSelectedGrupo(desconto.idGrupoDesconto);
    this.desconto = { ...desconto };
    this.caixaDialog = true;
  }

  delete(desconto: Desconto) {
    this.confirmationService.confirm({
      message: 'Você tem certeza que deseja remover o desconto: ' + desconto.nomeGrupoDesconto,
      header: 'Confirmação',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.descontoService
          .delDesconto(desconto)
          .subscribe(
            () => this.getDescontos(),
            err => {
              console.log("ERRO DESCONTO - DELETE")
              console.log(err)
            }
          );
        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Desconto removido com sucesso!', life: 3000 });
      }
    });
  }


  hideDialog() {
    this.caixaDialog = false;
    this.submitted = false;
  }
  
  saveFluxo() {
    this.submitted = true;

    if (this.desconto.idDesconto) {

      this.descontoService
        .updDesconto(this.desconto)
        .subscribe(
          //() => this.updProdutoGrupoDesconto(),
          () => this.getDescontos(),
          err => {
            console.log("ERRO DESCONTO - SAVE-UPD")
            console.log(err)
          }
        );
      this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Desconto atualizado com sucesso!', life: 3000 });
    } else {
      this.descontoService
        .addDesconto(this.desconto)
        .subscribe(
          //() => this.updProdutoGrupoDesconto(),
          () => this.getDescontos(),
          err => {
            console.log("ERRO DESCONTO - SAVE-ADD")
            console.log(err)
          }
        );

      this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Fluxo cadastrado com sucesso!', life: 3000 });
    }

    this.listaDesconto = [...this.listaDesconto];
    this.caixaDialog = false;
    this.desconto = {};
  }

  updProdutoGrupoDesconto() {
    this.produtoService
      .updProdutoGrupoDesconto(this.selectedProduto, this.desconto.idGrupoDesconto)
      .subscribe(
        () => this.getDescontos(),
        err => {
          console.log("ERRO DESCONTO - SAVE-GRUPO")
          console.log(err)
        }
      );
  }

  produtoClick(idProduto : number)
  {
    //TODO - Ajustar parametro e redirecionar tela produto (falta implementar)
    console.log("produto");
    console.log(idProduto);
  }
}

